import React, { useRef } from "react";
import { useState, useEffect } from "react";
import styles from "./Signup.module.css";
import { useHistory } from 'react-router-dom';
import Navbar from "../landing/sections/Navbar";
import signupImg from '../../assets/image/signup-img.jpg'
import LogoImg from '../../assets/image/landing-images/girl_bg.png'
import appVideo from '../../assets/vid.mp4'

import { doSignup, selectsignupSuccess, fetchGoogleConfig, selectGoogleConfig, doGoogleSignup, selectSignupUser, fetchFacebookConfig, selectFacebookConfig, doFacebookSignup, fetchRecaptchaConfig, selectRecaptchaConfig } from "./SignupSlice";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from 'bootstrap/dist/js/bootstrap.esm.min.js';
import thickwalletFullLogo from '../../assets/image/logo/thickWalletFullGreenAlignedLogo.png'
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import FacebookLoginButton from '../../components/auth/FacebookLoginButton';

export const Signup = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const signUpStatus = useSelector(selectsignupSuccess);
  const googleConfig = useSelector(selectGoogleConfig);
  const facebookConfig = useSelector(selectFacebookConfig);
  const recaptchaConfig = useSelector(selectRecaptchaConfig);
  const signupUser = useSelector(selectSignupUser);
  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [showPasswordborder, setShowPasswordborder] = useState(false);
  const pwdRule = useRef({ rule1: false, rule2: false, rule3: false, result: false });

  useEffect(() => {
    dispatch(fetchGoogleConfig());
    dispatch(fetchFacebookConfig());
    dispatch(fetchRecaptchaConfig());
  }, [dispatch]);

  useEffect(() => {
    // Redirect to home if user is logged in after signup
    if (signUpStatus && signupUser && Object.keys(signupUser).length) {
      history.push('/home');
    }
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.forEach(tooltipTriggerEl => {
    new Tooltip(tooltipTriggerEl);
  });
  }, [signUpStatus, signupUser, history])

  /**
   * Function to handle Google SSO signup success
   */
  const handleGoogleSuccess = (credentialResponse) => {
    if (credentialResponse?.credential) {
      dispatch(doGoogleSignup(credentialResponse.credential));
    }
  };

  /**
   * Function to handle Google SSO signup error
   */
  const handleGoogleError = () => {
    console.error('Google Sign-In failed');
  };

  /**
   * Function to handle Facebook SSO signup success
   */
  const handleFacebookSuccess = (accessToken) => {
    if (accessToken) {
      dispatch(doFacebookSignup(accessToken));
    }
  };

  /**
   * Function to handle Facebook SSO signup error
   */
  const handleFacebookError = (error) => {
    console.error('Facebook Sign-In failed:', error);
  };

  /**
   * Function to handle form input changes.
   * @param {*} e
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'password') {
      const result = validatePassword(value);
      // const {rule1, rule2, rule3} = result;
      pwdRule.current = result;
    }
    if(!pwdRule.current.result) {
      setShowPasswordborder(true);
    }else{
      setShowPasswordborder(false);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  /**
   * Function to execute reCAPTCHA and get token
   * @param {string} action - The action name for reCAPTCHA
   * @returns {Promise<string|null>} - The reCAPTCHA token or null if not available
   */
  const executeRecaptcha = async (action) => {
    if (!recaptchaConfig?.siteKey || !window.grecaptcha) {
      return null;
    }
    
    try {
      await window.grecaptcha.ready(() => {});
      const token = await window.grecaptcha.execute(recaptchaConfig.siteKey, { action });
      return token;
    } catch (error) {
      console.error('reCAPTCHA execution failed:', error);
      return null;
    }
  };

  /**
   * Function to handle the signup button
   */
  const signUp = async () => {
    if (validateSignupData()) {
      // Get reCAPTCHA token before signup
      const recaptchaToken = await executeRecaptcha('signup');
      
      const req = {
        givenName: formData.name,
        mobileNumber: formData.mobileNumber,
        email: formData.email,
        password: formData.password,
        recaptchaToken
      }
      dispatch(doSignup(req));
    }
  };

  const validatePassword = (password) => {
    const hasNumber = /\d/.test(password);
    const hasAlphabet = /[a-zA-Z]/.test(password);
    const hasMinLength = password.length >= 8;
    const hasMaxLength = password.length <= 24;
    let obj = {
      rule1: hasMinLength && hasMaxLength,
      rule2: hasAlphabet,
      rule3: hasNumber,
      result: (hasAlphabet && hasMinLength && hasMaxLength && hasNumber)
    }
    return obj;
  };

  const validateForm = () => {
    const { name, mobileNumber, email, password } = formData;
    if (isNameValid(name) && isMobileNumberValid(mobileNumber) && isEmailValid(email) && password  && pwdRule.current.result) return true;
    return false;
  }

  const isEmailValid = (email) => {
    if (!email) return false;
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  }

  const isMobileNumberValid = (number) => {
    if (!number) return false;
    const numberPattern = /^[0-9]{10}$/;
    return numberPattern.test(number);
  }

  const isNameValid = (name) => {
    if (!name) return false;
    const namePattern = /^[a-zA-Z\s]+$/;
    return namePattern.test(name);
  }




  /**
   * Function to validate the user inputs.
   * @returns boolean
   */
  const validateSignupData = () => {
    return true;
  };

  return (
    <div>
      {/* <Navbar style={{ position: "static" }} /> */}
      <div className={styles.signup_container}>

        <div className="container-fluid h-100">
          {/* <div className="row">
          <Navbar />

          </div> */}

          <div className={`row h-100 ${styles.signup_card}`}>
             {/* <div className={`col-lg-6 col-md-6 col-sm-12 ${styles.img_container}`}>
              <div className={styles.signup_img_wrapper}>
                <div className={styles.signup_logo}>
                </div>
              </div>
            </div> */}
            <div className={`col-lg-6 col-md-6 col-sm-12 d-none s-sm-block d-md-block ${styles.img_container}`}>
  <div className={styles.signup_img_wrapper}>
    <div className={styles.signup_logo}>
      <video
        autoPlay
        loop
        muted
        playsInline
        className={`h-100 ${styles.signup_video}`}
      >
        <source src={appVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</div>

            <div className="col-lg-4 col-md-4 col-sm-12 mx-auto">

              <div className={`vh-100 d-flex align-items-center justify-content-center ${styles.form_wrapper}`}>
                <div className={styles.close_icon} onClick={()=>{history.push("/")}}></div>
                <form className="w-100">
                  <div className="text-center pb-3">
                        <img src={thickwalletFullLogo} alt="" style={{maxWidth: "70%", height: "auto"}} />
                    </div>
                  <div className={styles.form_group}>
                    <div className={styles.floating_label}>
                    <input
                      type="text"
                      // className="form-control"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className={isNameValid(formData.name) ? styles.valid_input : styles.invalid_input}
                      placeholder=" "
                    />

                                        <label htmlFor="name">Name</label>
                    </div>
                    <span className={styles.form_error}>{(!isNameValid(formData.name) && formData.name) ? 'Name can only contain alphabets and spaces.' : null}</span>
                  </div>
                  <div className={styles.form_group}>
                    <div className={styles.floating_label}>
                    <input
                      type="text"
                      // className="form-control"
                      id="mobileNumber"
                      name="mobileNumber"
                      value={formData.mobileNumber}
                      onChange={handleChange}
                      className={isMobileNumberValid(formData.mobileNumber) ? styles.valid_input : styles.invalid_input}

                      required
                      placeholder=" "
                    />
                                        <label htmlFor="mobileNumber">Mobile Number</label>
                    </div>
                    <span className={styles.form_error}>{(!isMobileNumberValid(formData.mobileNumber) && formData.mobileNumber) ? 'Invalid Mobile Number' : null}</span>
                  </div>

                  <div className={styles.form_group}>
  <div className={styles.floating_label}>
    <input
      type="email"
      id="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      className={isEmailValid(formData.email) ? styles.valid_input : styles.invalid_input}
      required
      placeholder=" " // Important: placeholder with a space triggers :placeholder-shown
    />
    <label htmlFor="email">Email</label>
  </div>
  <span className={styles.form_error}>
    {(!isEmailValid(formData.email) && formData.email) ? 'Invalid Email' : null}
  </span>
</div>

                  <div className={`${styles.form_group} position-relative`}>
                  <div className={styles.floating_label}>

                    <input
                      type="password"
                      // className="form-control"
                      id="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      placeholder=" "
                      className={showPasswordborder ? styles.invalid_input : styles.valid_input}
                    />

                    <label htmlFor="password">Password</label>
                    </div>
                    <div className="position-absolute" style={{ right: "-25px", top: "20%" }}>
      <span
        className="d-inline-block"
        data-bs-toggle="tooltip"
        data-bs-html="true"
        data-bs-original-title={`
          <ul class="text-start mb-0 ps-3">
            <li class="${pwdRule.current.rule1 ? 'text-success' : ''}">Should be between 8-24 characters</li>
            <li class="${pwdRule.current.rule2 ? 'text-success' : ''}">Should contain a alphabet</li>
            <li class="${pwdRule.current.rule3 ? 'text-success' : ''}">Should contain a number</li>
          </ul>
        `}
      >
        <i className="bi bi-info-circle"></i>
      </span>
    </div>
                    {/* <ul className={styles.password_rules}>
                      <li className={pwdRule.current.rule1 ? styles.color_green : null}>Minimum length should be 6</li>
                      <li className={pwdRule.current.rule2 ? styles.color_green : null}>Should contain a alphabet</li>
                      <li className={pwdRule.current.rule3 ? styles.color_green : null}>Should contain a number</li>
                    </ul> */}
                  </div>
                <div className="text-center">
                       <input
                    type="button" disabled={!validateForm()}
                    className={styles.signup_btn}
                    onClick={signUp}
                    value='Sign Up'
                  />
                </div>
                {(googleConfig?.clientId || facebookConfig?.appId) && (
                <>
                <div className={styles.divider}>
                  <span>or</span>
                </div>

                <div className={styles.oauth_btn_wrapper}>
                  {googleConfig?.clientId && (
                    <div className={styles.google_btn_wrapper}>
                      <GoogleOAuthProvider clientId={googleConfig.clientId}>
                        <GoogleLogin
                          onSuccess={handleGoogleSuccess}
                          onError={handleGoogleError}
                          text="signup_with"
                          shape="rectangular"
                          width="100%"
                        />
                      </GoogleOAuthProvider>
                    </div>
                  )}
                  {facebookConfig?.appId && (
                    <div className={styles.facebook_btn_wrapper}>
                      <FacebookLoginButton
                        appId={facebookConfig.appId}
                        onSuccess={handleFacebookSuccess}
                        onError={handleFacebookError}
                        text="signup_with"
                      />
                    </div>
                  )}
                </div>
                </>
                )}

                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};
